import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecp-template',
  templateUrl: './ecp-template.component.html',
  styleUrls: ['./ecp-template.component.css']
})
export class EcpTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
